'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CdsImage = require('./CdsImage');

var _reactImageGallery = require('react-image-gallery');

var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);

var _translate = require('@esnpm/translate');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CdsGallery = (_temp = _class = function (_React$Component) {
	_inherits(CdsGallery, _React$Component);

	function CdsGallery(props) {
		_classCallCheck(this, CdsGallery);

		var _this = _possibleConstructorReturn(this, (CdsGallery.__proto__ || Object.getPrototypeOf(CdsGallery)).call(this, props));

		_this.state = {
			loading: true
		};
		return _this;
	}

	_createClass(CdsGallery, [{
		key: 'handleOnLoaded',
		value: function handleOnLoaded() {
			this.setState({ loading: false });
		}
	}, {
		key: 'getItems',
		value: function getItems() {
			var _this2 = this;

			var options = {
				original: {
					width: this.props.width,
					height: this.props.height,
					watermark: true
				},
				thumbnail: {
					width: this.props.thumbWidth,
					height: this.props.thumbHeight
				}
			};

			var ordered = [];
			ordered.push.apply(ordered, _toConsumableArray(this.props.assets.filter(function (a) {
				return a.ASSET_TYPE === "PRODUCT_MAIN_PICTURE";
			})));
			ordered.push.apply(ordered, _toConsumableArray(this.props.assets.filter(function (a) {
				return a.ASSET_TYPE === "PRODUCT_PICTURE";
			})));

			return Object.values(ordered).map(function (asset, index) {
				var original = (0, _CdsImage.getPicParams)(Object.assign({}, options.original, { asset: asset }));
				var thumbnail = (0, _CdsImage.getPicParams)(Object.assign({}, options.thumbnail, { asset: asset }));

				var ret = {
					original: original.url,
					thumbnail: thumbnail.url
				};

				if (typeof original.alt !== "undefined" || _this2.props.altFallbackString !== "") {
					var alt = (typeof original.alt !== "undefined" ? original.alt : _this2.props.altFallbackString) + " - " + (index + 1);
					ret.originalAlt = alt;
					ret.thumbnailAlt = alt + " - " + "Thumbnail";
				}

				return ret;
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var items = this.getItems();

			var newProps = Object.assign({}, this.props, {
				items: items
			});

			return _react2.default.createElement(_reactImageGallery2.default, newProps);
		}
	}]);

	return CdsGallery;
}(_react2.default.Component), _class.propTypes = {
	assets: _propTypes2.default.array,
	width: _propTypes2.default.number,
	height: _propTypes2.default.number,
	thumbWidth: _propTypes2.default.number,
	thumbHeight: _propTypes2.default.number,
	altFallbackString: _propTypes2.default.string,
	lazyLoad: _propTypes2.default.bool,
	showFullscreenButton: _propTypes2.default.bool,
	showPlayButton: _propTypes2.default.bool,
	showBullets: _propTypes2.default.bool,
	useTranslate3D: _propTypes2.default.bool,
	showThumbnails: _propTypes2.default.bool,
	additionalClass: _propTypes2.default.string
}, _class.defaultProps = {
	assets: [],
	width: 600,
	height: 400,
	thumbWidth: 160,
	thumbHeight: 120,
	altFallback: "",
	lazyLoad: false,
	showFullscreenButton: false,
	showPlayButton: false,
	showBullets: false,
	useTranslate3D: false,
	showThumbnails: true,
	additionalClass: "CdsGallery"
}, _temp);
exports.default = (0, _redux.compose)(_translate.withTrContext)(CdsGallery);